<template>
        <div
          v-show="false"
          id="print-html"
          style="width: 100%; padding: 0px; display: flex; flex-direction: column; flex-wrap: wrap;"
        >
          <div
            style="display: flex; justify-content: space-between; flex-direction: row; flex-wrap: nowrap; width: 100%;"
          >
            <img :style="`min-height: 55px !important; max-height: 55px !important;`" :src="getLoggedUser.tenant[0].profileImage" alt="" />
            <div style="display: flex; align-items: center; flex-direction: column; padding-right: 7px; padding-left: 7px; ">
              <span class="font-head-title">
                {{ getLoggedUser.tenant[0].nome }}
              </span>
              <span class="font-head-subtitle">
                CNPJ: {{ getLoggedUser.tenant[0].cnpj }}
              </span>
              <span
                v-if="getLoggedUser.tenant[0].address"
                class="font-head-subtitle"
              >
                {{ getLoggedUser.tenant[0].address.formatted_address }}
              </span>
              <span
                class="font-head-subtitle"
                v-if="getLoggedUser.tenant[0].phone"
              >
                {{ getLoggedUser.tenant[0].phone }}
              </span>
            </div>
            <div
              class="font-head-subtitle"
              style="font-size: 9pt;display: flex; width: 15%; justify-content: center;"
            >
              {{ getLoggedUser.tenant[0].receipt_config.top_right_text }} 
            </div>
          </div>
          <div
            style="margin-top: 12px;display: flex; justify-content: center; flex-wrap: wrap; width: 100%;"
          >
            <span class="font-title">PROPOSTA ORÇAMENTARIA</span>
          </div>
          <div
            style="padding: 6px; padding-left: 0px; padding-right: 0px; display: flex; width: 100%; flex-direction: column; flex-wrap: wrap; width: 100%;"
          >
            <div style="display: flex; width: 100%;" v-if="lastSell.compra.cliente">
              <span class="font-head-title" style="margin-right: 18px;">
                Cliente:
              </span>
              <div style="padding-left: 2px; display: flex; min-width: 90%; border-bottom: 1px solid #f2f1f1;">
                <span class="font-head-subtitle">
                  {{ lastSell.compra.cliente.nome }}       
                </span>
              </div>
            </div>
            <div style="display: flex; width: 100%; margin-top: 4px;" v-if="lastSell.compra.cliente && lastSell.compra.cliente.telefone">
              <span class="font-head-title" style="margin-right: 6px;">
                Telefone:
              </span>
              <div style="padding-left: 2px; display: flex; min-width: 90%; border-bottom: 1px solid #f2f1f1;">
                <span class="font-head-subtitle">
                  {{ lastSell.compra.cliente.telefone }}
                </span>
              </div>
            </div>
            <div style="display: flex; width: 100%; margin-top: 4px;" v-if="lastSell.compra.obra">
              <span class="font-head-title" style="margin-right: 6px;">
                Obra:
              </span>
              <div style="padding-left: 2px; display: flex; min-width: 90%; border-bottom: 1px solid #f2f1f1;">
                <span class="font-head-subtitle">
                  {{ lastSell.compra.obra.nome }}, {{ lastSell.compra.obra.comodos.length }} cômodos.
                </span>
              </div>
            </div>
          </div>
          <div
            style="display: flex; width: 100% !important; margin-top: 6px; margin-bottom: 6px; padding: 0px;"
          >
            <table
              style="witdh: 100% !important; background: #f0f0f0;"
            >
              <template>
                  <tr
                    class="tr-table"
                    style="width: 100%; background: #f7f7f7; border: 1px solid #f0f0f0;"
                  >
                    <td
                      style="padding-right: 2px; text-align: center; padding-left: 2px; color: #878686; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        QTD
                      </span>
                    </td>
                    <td
                      style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        D I S C R I M I N A Ç Ã O
                      </span>
                    </td>
                    <td
                      style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        MEDIDA
                      </span>
                    </td>
                    <td
                      style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        UN
                      </span>
                    </td>
                    <td
                      style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
                    >
                      <span class="font-head-title">
                        VALOR
                      </span>
                    </td>
                    <td
                      style="color: #878686;padding-right: 10px; padding-left: 10px; "
                    >
                      <span class="font-head-title">
                        TOTAL
                      </span>
                    </td>
                  </tr>
                  <template
                    v-for="(item, i2) in lastSell.compra.produtos"
                  >
                    <tr
                      style="background: #cccaca; border-bottom: 3px dashed #cccaca;"
                      :key="`desc-perso-${i2}`"
                    >
                      <td
                        class="fonte fonte-micro"
                        style="color: #cccaca; padding-right: 10px; padding-left: 10px;"
                      >
                        <span class="font-head-subtitle">
                          ---
                        </span>
                      </td>
                      <td
                        class="fonte fonte-micro"
                        style="color: #cccaca;padding-right: 10px; padding-left: 10px;"
                      >
                        <span class="font-head-title">
                          {{
                            item.descricao_personalizada
                              ? item.descricao_personalizada
                              : item.nome
                          }} {{ item.comodo ? `- ${item.comodo}` : "" }}
                        </span>
                      </td>
                      <td style="color: #cccaca"> <span class="font-head-subtitle"> --- </span> </td>
                      <td style="color: #cccaca"> <span class="font-head-subtitle"> --- </span> </td>
                      <td style="color: #cccaca"> <span class="font-head-subtitle"> --- </span> </td>
                      <td style="color: #cccaca"> <span class="font-head-subtitle"> --- </span> </td>
                    </tr>
                    <tr
                      v-for="(ficha, i) in item.ficha_tecnica"
                      class="tr-table"
                      style="background: #f0f0f0; width: 100%;"
                      :key="`item-ficha-prod-${i}-${i2}`"
                      v-show="ficha.quantity && ficha.quantity >= 1"
                    >
                      <td
                        class="fonte fonte-micro"
                        style="color: #f7f7f7; text-align: center;"
                      >
                        <span class="font-head-title">
                          {{ ficha.quantity }}
                        </span>
                      </td>
                      <td
                        class="fonte fonte-micro"
                        style="padding-right: 10px; padding-left: 10px;"
                      >
                        <span class="font-head-subtitle">
                          {{ ficha.descricao ? ficha.descricao : "" }} -
                          {{ item.nome }}
                        </span>

                      </td>
                      <td
                        class="fonte fonte-bold"
                        style="padding-right: 10px; padding-left: 10px; text-wrap: nowrap;"
                        v-if="ficha.comprimento || ficha.largura"
                      >
                        <span class="font-head-subtitle">
                          {{ formatMeasure(ficha.comprimento) }} x {{ formatMeasure(ficha.largura) }}
                        </span>
                      </td>
                      <td
                        class="fonte fonte-bold"
                        style="color: #494949;padding-right: 10px; padding-left: 10px;"
                        v-else
                      >
                        <span class="font-head-subtitle">
                          ##
                        </span>
                      </td>
                      <td
                        class="fonte fonte-bold"
                        style="color: #494949;padding-right: 10px; padding-left: 10px;"
                      >
                        <span class="font-head-subtitle">
                          {{ verifyUnit(ficha) }}
                        </span>
                      </td>
                      <td
                        class="fonte fonte-bold"
                        style="padding-right: 10px; padding-left: 10px; text-wrap: nowrap;"
                      >
                        <span class="font-head-subtitle">
                          {{ $helper.formataSaldo(ficha.preco) }}
                        </span>
                      </td>
                      <td
                        class="fonte fonte-micro"
                        style="padding-right: 10px; padding-left: 10px;text-align: right; text-wrap: nowrap;"
                      >
                        <span class="font-head-subtitle">
                          {{
                            $helper.formataSaldo(parseFloat(ficha.total))
                          }}
                        </span>
                      </td>
                    </tr>
                  </template>
              </template>
            </table>
          </div>
          <div
            style="padding: 3px;padding-right: 6px; padding-left: 6px;display: flex; justify-content: space-between; flex-wrap: nowrap; width: 100%;"
          >
            <table>
              <tr>
                <td style="width: 100%;"></td>
                <td style="padding-right: 6px; text-align: right;text-wrap: nowrap;">
                  <span class="font-head-title">ACABAMENTO R$</span>
                </td>
                <td style="text-align: right;padding-right: 14px;">
                  <span style="text-wrap: nowrap;" class="font-head-subtitle">
                    + {{ $helper.formataSaldo(lastSell.compra.acabamento || 0) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td style="width: 100%;"></td>
                <td style="padding-right: 6px; text-align: right;text-wrap: nowrap;">
                  <span class="font-head-title">TOTAL SEM DESCONTO R$</span>
                </td>
                <td style="text-align: right;padding-right: 10px;">
                  <span style="text-wrap: nowrap;text-align: right;" class="font-head-subtitle bg-texts">
                    = {{ $helper.formataSaldo(lastSell.compra.subtotal) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td style="width: 100%;"></td>
                <td style="padding-right: 6px; text-align: right;text-wrap: nowrap;border-bottom: 1px solid #c6c6c6;">
                  <span class="font-head-title">
                    {{
                      lastSell.compra.desconto_type &&
                      lastSell.compra.desconto_type === "percent"
                        ? `${lastSell.compra.desconto_applyed}% DE`
                        : ""
                    }} DESCONTO, R$</span>
                </td>
                <td style="text-align: right;padding-right: 14px;border-bottom: 1px solid #c6c6c6;">
                  <span style="text-wrap: nowrap;text-align: right;" class="font-head-subtitle">
                    - {{ $helper.formataSaldo(lastSell.compra.desconto || 0) }}
                  </span>
                </td>
              </tr>
              <tr>
                <td style="width: 100%;"></td>
                <td style="padding-right: 6px; text-align: right; text-wrap: nowrap;">
                  <span class="font-head-title">TOTAL COM DESCONTO R$</span>
                </td>
                <td style="text-align: right;padding: 10px;">
                  <span style="text-wrap: nowrap;text-align: right;" class="font-head-subtitle bg-texts">
                    = {{ $helper.formataSaldo(lastSell.compra.preco_total) }}
                  </span>
                </td>
              </tr>
            </table>
          </div>

          <div
            style="color: #bebcbc; margin-top: 36px; display: flex; width: 100%; justify-content: center;"
          >
            _________________________________________________________________
          </div>
          <div
            style="display: flex; width: 100%; justify-content: center;"
          >
            <span class="font-head-title">
              AUTORIZO
            </span>
          </div>
          <div
            style="margin-bottom: 12px; margin-top: 4px; flex-direction: column; display: flex; width: 100%;"
          >
            <div style="display: flex; width: 100%; justify-content: center;">
              <span v-if="getLoggedUser.tenant[0].receipt_config && getLoggedUser.tenant[0].receipt_config.show_header_text" class="font-head-subtitle">
                {{ getLoggedUser.tenant[0].receipt_config.show_header_text.text }}
              </span>
            </div>
            <table>
              <tr>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">DATA DE EMISSÃO</th>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">OBSERVAÇÕES</th>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">Nº DO DOCUMENTO</th>
              </tr>

              <tr>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    {{ moment().format("DD/MM/YYYY HH:mm") }}
                  </span>
                </td>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">{{ getLoggedUser.tenant[0].receipt_config.short_obs }}</span>
                </td>
                <td style="max-width: 70px; border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding: 6px; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">{{ lastSell.id_transacao }}</span>
                </td>
              </tr>

              <tr>
                <th style="background: #e2e0e0;border-bottom: 1px solid #e2e0e0 !important;">VALIDADE DA PROPOSTA</th>
                <th style="padding-left: 6px;background: #fff;">
                  <span style="display: flex; width: 100%;" class="font-head-subtitle">
                    Atenciosamente,
                  </span>
                </th>
                <th>*</th>
              </tr>

              <tr style="margin-botom: 0px; padding-bottom: 0px;">
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    {{ proposalValidity(lastSell) }}
                  </span>
                </td>
                <td style="border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="padding-left: 6px; display: flex; width: 100%; align-items: center;" class="font-head-subtitle">
                    <span>{{ this.getLoggedUser.nome }}</span>
                  </span>
                </td>
                <td style="max-width: 70px; border-bottom: 1px solid #e2e0e0 !important;">
                  <span style="font-size: 9pt; display: flex; width: 100%; justify-content: center;" class="font-head-subtitle">
                    {{ getLoggedUser.tenant[0].receipt_config.bottom_right_text }}
                  </span>
                </td>
              </tr>
            </table>
            <div style="display: flex; width: 100%; justify-content: center;">
              <span v-if="getLoggedUser.tenant[0].receipt_config && getLoggedUser.tenant[0].receipt_config.show_footer_text" class="font-head-subtitle">
                {{ getLoggedUser.tenant[0].receipt_config.show_footer_text.text }}
              </span>
            </div>
          </div>
        </div>
</template>

<script>
import Moment from "moment";
import { formatMeasure } from "@/apps/shared/utils/measurements";

export default {
  name: "SaleBudgetPrint",
  props: {
    lastSell: {
      type: Object,
      default: () => ({ compra: { cliente: {}, produtos: [] } })
    },
    getLoggedUser: {
      type: Object,
      default: () => ({ tenant: [{ receipt_config: {} }] })
    }
  },
  data() {
    return { moment: Moment };
  },
  methods: {
    formatMeasure,
    proposalValidity(sale) {
      if (sale && sale.proposal_expires_at) {
        return Moment(sale.proposal_expires_at).format("DD/MM/YYYY HH:mm");
      }
      const days = this.getLoggedUser.tenant[0].receipt_config.validate_proposal_in_days || 7;
      return Moment(sale && sale.created_at).add(days, "days").format("DD/MM/YYYY HH:mm");
    },
    verifyUnit(item) {
      const type = String(item.type || "");
      const isStonePiece = type.includes("Secund") || type.includes("Principal");
      if (isStonePiece && parseFloat(item.largura) <= 0.1) return "ML";
      if (isStonePiece && parseFloat(item.largura) > 0.1) return "M\u00B2";
      if (item.type === "Acabamento") return "UND";
      return item.unit || "";
    }
  }
};
</script>
